import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { RentalDispenseMaterialization } from "@/models/rental-dispense-materialization.model"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export const useRentalDispenseMaterializationStore = defineStore(
  "rentalDispenseMaterializationStore",
  () => {
    const rentalDispenseMaterializations: Ref<RentalDispenseMaterialization[]> = ref([])

    function removeRentalDispenseMaterialization(item: RentalDispenseMaterialization) {
      const index = rentalDispenseMaterializations.value.findIndex(
        (materialization) => materialization.id === item.id
      )
      if (index !== -1) {
        rentalDispenseMaterializations.value.splice(index, 1)
      }
    }

    useSocketSynchronizationHandlers(
      RentalDispenseMaterialization,
      rentalDispenseMaterializations,
      undefined,
      removeRentalDispenseMaterialization,
      false
    )

    return {
      rentalDispenseMaterializations,
      removeRentalDispenseMaterialization
    }
  }
)
